<template>
  <div id="divTaskTooltip" ref="divToolTip" class="tooltipevent" :style="tooltipDivStyle"  >
    <h2 :style="h2ColorStyle">
      <svg width="18px" height="18px" fill="#FFF">
        <use :xlink:href="GetPriorityIcon()" />
      </svg>
      {{ EventTitle }}
    </h2>
    <strong>Patient Name:</strong> {{ thisEvent.extendedProps.patName }}
    <br /><strong>Patient Number:</strong>  {{ thisEvent.extendedProps.patNumber }}
    <br /><strong>Clinic Type:</strong>{{ thisEvent.extendedProps.clinicalType }}
    <br /><strong>Visit Type:</strong>{{ thisEvent.extendedProps.visitType }}
    <br /><strong>Transportation:</strong>  {{ thisEvent.extendedProps.transportationName }}
    <br /><strong>Transport Note:</strong>  {{ thisEvent.extendedProps.transportNote }}
    <br /><strong>Scheduled On:</strong>{{ thisEvent.extendedProps.scheduledOn }}
    <br /><strong>Scheduled By:</strong>{{ thisEvent.extendedProps.scheduledBy }}
    <br /><strong>Provider Info:</strong>{{ thisEvent.extendedProps.consultProviderData }}

    <div v-if="thisEvent.extendedProps.isComplete">
      <br /><strong>Completed On:</strong> {{ thisEvent.extendedProps.completedOn }}
      <br /><strong>Completed By:</strong> {{ thisEvent.extendedProps.completedBy }}
    </div>
  </div>
</template>

<script>
// import $ from "jquery";

export default {
  name: "event-tooltip",
  props: {
    thisEvent: Object,
    jsEvent: Object,
  },
  data: function () {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      tipWidth: 0,
      tipHeight: 0,
    };
  },
  computed: {
    EventTitle() {
      let vm = this;

      // let tooltipTime = "";

      const time = new Date(vm.thisEvent.start);
      let hour = time.getHours();
      let minute = (time.getMinutes()<10?'0':'') + time.getMinutes();

        // if (vm.eventTimeText != null)
        //   tooltipTime = vm.eventTimeText + " ";

      //   if (vm.thisEvent.extendedProps.endTime != null) {
      //     if (vm.thisEvent.extendedProps.startTime != null) {
      //       tooltipTime = vm.thisEvent.extendedProps.startTime + "-" + vm.thisEvent.extendedProps.endTime + " ";
      //     } else {
      //       tooltipTime = vm.thisEvent.start.format("l") + "-" + vm.thisEvent.extendedProps.endTime + " ";
      //     }
      //   }
      return `${hour}:${minute} ` + vm.thisEvent.title;
    },
    h2ColorStyle() {
      let vm = this;
      let h2_color = "white",
        h2_backColor = "";

        if (vm.thisEvent.extendedProps.isComplete) {
            h2_backColor = "#27b137";
        } else if (vm.thisEvent.extendedProps.apptStatus == 3) {
            h2_backColor = "#6A1B9A";
        } else if (vm.thisEvent.extendedProps.apptStatus == 2) {
            h2_backColor = "#1565C0";
      } else {
        h2_backColor = "#3d4049";
     }

      return "background:" + h2_backColor + "; color:" + h2_color + ";";
    },
    tooltipDivStyle() {
      let vm = this;
      let h2_backColor = "", backColor = "";
      if (vm.thisEvent.extendedProps.isComplete) {
        h2_backColor = "#27b137";
        backColor = "#dff8e2";
    } else if (vm.thisEvent.extendedProps.apptStatus == 3) {
        h2_backColor = "#6A1B9A";
        backColor = "#bf7de8";
    } else if (vm.thisEvent.extendedProps.apptStatus == 2) {
        h2_backColor = "#1565C0";
        backColor = "#8cbcf2";
    } else {
        h2_backColor = "#3d4049";
        backColor = "#e2e3e7";
    }

      var mousex = vm.jsEvent.pageX; //Get X coodrinates
      var mousey = vm.jsEvent.pageY; //Get Y coordinates
    //console.log('mousex:' + mousex);
    //console.log('mousey:' + mousey);

    //Distance of element from the right edge of viewport
      var tipVisX = vm.windowWidth - (mousex + vm.tipWidth);
      //Distance of element from the bottom of viewport
      var tipVisY = vm.windowHeight - (mousey + vm.tipHeight);

      if (tipVisX < 20) {
        //If tooltip exceeds the X coordinate of viewport
        mousex = vm.jsEvent.pageX - vm.tipWidth - 20;
      }
      if (tipVisY < 20) {
        //If tooltip exceeds the Y coordinate of viewport
        mousey = vm.jsEvent.pageY - vm.tipHeight - 20;
      }

      return "top: " + mousey + "px; left: " + mousex + "px; background:" + backColor + "; border-color:" + h2_backColor + ";";
    },

  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
        var vm = this;
        vm.windowWidth = window.innerWidth;
        vm.windowHeight = window.innerHeight;
        if (this.$refs.divToolTip) {
              var thisTooltip = vm.$refs.divToolTip;
              vm.tipWidth = thisTooltip.clientWidth; //Find width of tooltip
              vm.tipHeight = thisTooltip.clientHeight; //Find height of tooltip
        }
    },
    GetPriorityIcon() {
        var vm = this;

        if (vm.thisEvent.extendedProps.apptStatus == 3) {
          return "/App_Themes/default1/icons/sapphire-svg-sprites.svg#cancelFilledIcon";
        }
        else if (vm.thisEvent.extendedProps.apptStatus == 2) {
           return "/App_Themes/default1/icons/sapphire-svg-sprites.svg#followUpIcon";
        }
        else if (vm.thisEvent.extendedProps.apptStatus == 1) {
           return "/App_Themes/default1/icons/sapphire-svg-sprites.svg#confirmFilledIcon";
        }
        //Add Routine icon
        else {
          return "/App_Themes/default1/icons/sapphire-svg-sprites.svg#routineIcon";
        }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Tooltip div that displays when you hover over an event. */
.tooltipevent {
  border: 1px solid;
  z-index: 10001;
  text-align: left;
  width: 250px;
  position: absolute;
  border-radius: 5px;
  font-family: "Roboto", sans-serif;
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.6);
  opacity: 0;
  -webkit-animation: fadeInOpacity 0.3s forwards;
  animation: fadeInOpacity 0.3s forwards;
}
.tooltipevent h2 {
  padding: 5px;
  font-size: 14px;
}
.tooltipevent p {
  padding: 15px;
  font-size: 11px;
  line-height: 16px;
}

</style>
